import { NodeColumns } from '../../../stores/table-store';

export type GroupRowCellKind =
  | 'control' // index column: drag handle + expand/collapse chevron
  | 'topNumber' // nodeNumber column: read-only Node # of the group's top node
  | 'count' // nodeType column: read-only node count badge
  | 'nameAndActions' // nodeName column: editable group name + action buttons
  | 'empty'; // any other column: decorative, no content

/**
 * The group-header cell kind for a column, by column id.
 *
 * ⚠️ PSTUDIO-3865: this no longer decides WHERE the header content renders —
 * content is placed POSITIONALLY by `computeGroupHeaderLayout` (first four
 * visible non-control columns), independent of column id. The only functional
 * use of the kind now is `=== 'control'` (the leading index/chevron+drag cell,
 * which stays a dedicated service column and never hosts a content slot); the
 * `count`/`topNumber`/`nameAndActions` mappings drive ONLY the cosmetic
 * `c-editor-table-tr-group__cell--${kind}` class, so after a pin/reorder a
 * `--count` cell may NOT be the cell that hosts the count. Do not reintroduce
 * content placement based on this kind — use the positional layout.
 */
export const groupRowCellKind = (columnId: string): GroupRowCellKind => {
  if (columnId === 'index') return 'control';
  if (columnId === NodeColumns.nodeNumber) return 'topNumber';
  if (columnId === NodeColumns.nodeType) return 'count';
  if (columnId === NodeColumns.nodeName) return 'nameAndActions';
  return 'empty';
};
